import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import WSChat from 'apps/promo/components/chat/WSChat';
import Popup from 'apps/promo/components/common/Popup/Popup';
import PromoSpinner from 'apps/promo/components/common/promo-spinner/PromoSpinner';
import Footer from 'apps/promo/components/footer/Footer';
import HeaderFixed from 'apps/promo/components/header-fixed/HeaderFixed';
import NotFound from 'apps/promo/components/NotFound';
import { useGetQueryParams } from 'apps/promo/components/utils';
import BasePageForNoAuth from 'apps/promo/components/utils/BasePageForNoAuth';
import MessageBodyService from 'apps/promo/components/utils/MessageBodyService';
import { AUTH_SEND_MAIN_LINK } from 'apps/promo/constants/UrlConstants';
import colors from 'apps/promo/theme/colors';

const PageWrapper = styled.main`
    background-color: ${(props) => (props.useThemeColor ? props.theme.white : colors.white)};
    color: ${(props) => (props.useThemeColor ? props.theme.black : colors.black)};
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export default function NotAuthBasePage(PageComponent) {
    const ComposedComponent = (props) => {
        const [backUrl, setBackUrl] = useState(AUTH_SEND_MAIN_LINK);
        const lang = props.noAuthFooter?.language?.lang ? props.noAuthFooter.language.lang : props.backendLang;
        const country = props.noAuthFooter?.language?.country ? props.noAuthFooter.language.country : props.backendCountry;
        const renderOptions = props.renderOptions;

        const urlParams = useGetQueryParams();

        useEffect(() => {
            if (__isBrowser__ && document) {
                const referrer = document.referrer;
                const isFromAuth = referrer?.includes('/auth/');
                const savedPrevUrl = sessionStorage.getItem('prevUrl');

                if (isFromAuth && !savedPrevUrl) {
                    const backPath = new URL(referrer).pathname;
                    sessionStorage.setItem('prevUrl', backPath);
                    setBackUrl(backPath);
                } else if (savedPrevUrl) {
                    setBackUrl(savedPrevUrl);
                }
            }
        }, []);

        const renderChat = () => {
            if (renderOptions?.isBusinessConnect || renderOptions?.isApplePay || renderOptions?.isHelpMobile || !props.showZendeskChat) {
                return null;
            }

            return <WSChat />;
        };

        if (props.notFound) {
            return <NotFound />;
        }

        const showHeader =
            !props.loading &&
            !renderOptions?.isHelpMobile &&
            !renderOptions?.headerHidden &&
            Array.isArray(props.newMenuObject) &&
            props.newMenuObject.length > 0;

        return (
            <>
                {showHeader && (
                    <HeaderFixed
                        loading={props.loading}
                        isShowNavModal={props.isShowNavModal}
                        menuSection={props.stateOptions?.menuSection}
                        data={props.newMenuObject}
                        pageName={props.stateOptions?.pageName}
                        promoDarkPage={renderOptions?.promoDarkPage}
                        blackLogo={renderOptions?.blackLogo}
                        libre={renderOptions?.isLibre}
                        hasChatButton={renderOptions?.hasChatButton}
                        isBlogPage={props.stateOptions?.section === 'blog'}
                        hideNavigation={renderOptions?.hideNavigation}
                        isReferral={renderOptions?.isReferralPage}
                    />
                )}
                <PageWrapper useThemeColor={renderOptions?.isHelpMobile} className={'lock_container'} style={{ opacity: `${props.loading ? '0.3' : '1'}` }}>
                    {!props.loading && (
                        <PageComponent
                            {...props}
                            data={props.data}
                            loading={props.loading}
                            renderOptions={renderOptions}
                            backUrl={backUrl}
                            headerHidden={renderOptions?.headerHidden}
                        />
                    )}
                </PageWrapper>
                <PromoSpinner forceShow={props.loading} />
                {!props.loading && !renderOptions?.isHelpMobile && (
                    <Footer
                        renderOptions={renderOptions}
                        data={props.noAuthFooter}
                        lang={lang}
                        country={country}
                        isLanding={false}
                        c3p0={urlParams.version === 'c3p0'}
                    />
                )}
                {renderChat()}
                <MessageBodyService />
                <Popup />
                {props.isShowModal && props.modalComponent}
            </>
        );
    };

    const mapStateToProps = (state) => {
        return {
            noAuthFooter: state.extra.noAuthFooter,
            notFound: state.extra.notFound,
            isShowNavModal: state.app.isShowNavModal,
            modalComponent: state.app.modalComponent,
            isShowModal: state.app.isShowModal,
            lang: state.extra.noAuthFooter?.language?.lang,
            country: state.extra.noAuthFooter?.language?.country,
            newMenuObject: state.extra.newNoAuthMenu?.header,
            showZendeskChat: state.extra.noAuthFooter?.showZendeskChat,
        };
    };
    return connect(mapStateToProps)(BasePageForNoAuth(ComposedComponent));
}
